import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { FormsModule } from "@angular/forms";

import { BfxSharedModule } from "../bfx-shared/bfx-shared.module";

import { TranslateModule } from "@ngx-translate/core";
import { CheckboxModule } from "@bfx/primeng/checkbox";
import { DataTableModule } from "@bfx/primeng/datatable";
import { InputTextModule } from "@bfx/primeng/inputtext";
import { InputTextareaModule } from "@bfx/primeng/inputtextarea";
import { TabViewModule } from "@bfx/primeng/tabview";

//perfect scrollbar
import { PerfectScrollbarModule } from "@bfx/ngx-perfect-scrollbar";
import { PerfectScrollbarConfigInterface } from "@bfx/ngx-perfect-scrollbar";
import { PERFECT_SCROLLBAR_CONFIG } from "@bfx/ngx-perfect-scrollbar";
import { BfxContactManagerComponent } from "./bfx-contact-manager.component";
import { FlexLayoutModule } from "@angular/flex-layout";
import { BfxContactEditComponent } from "./bfx-contact-edit.component";
import { BfxClientTraderEditComponent } from "./bfx-client-trader-edit.component";
import { NativeDesktopModule } from "../bfx-native-desktop/native-desktop-support.module";
import { BaseComponentsModule } from "shared/base-components/base-components.module";

const DEFAULT_PERFECT_SCROLLBAR_CONFIG: PerfectScrollbarConfigInterface = {
  suppressScrollX: true,
};

@NgModule({
  imports: [
    CommonModule,
    DataTableModule,
    BfxSharedModule,
    TranslateModule,
    CheckboxModule,
    FormsModule,
    InputTextModule,
    InputTextareaModule,
    TabViewModule,
    FlexLayoutModule,
    DataTableModule,
    NativeDesktopModule,
    PerfectScrollbarModule,
    BaseComponentsModule,
  ],
  providers: [
    {
      provide: PERFECT_SCROLLBAR_CONFIG,
      useValue: DEFAULT_PERFECT_SCROLLBAR_CONFIG,
    },
  ],
  declarations: [BfxContactManagerComponent, BfxContactEditComponent, BfxClientTraderEditComponent],
  exports: [BfxContactManagerComponent, BfxContactEditComponent, BfxClientTraderEditComponent],
  bootstrap: [BfxContactManagerComponent, BfxContactEditComponent, BfxClientTraderEditComponent],
})
export class BfxContactManagerModule {}
